export function getIntercomUser() {
  var user = (JSON.parse(localStorage.getItem('userData')) || null);
  if (user === null){
    return {}
  }
  var ic_user = {
    email: user.email,
    name: user.first_name + " " + user.last_name,
    user_id: user.id,
    entity_type: user.entity_type,
    entity_id: user.entity_id,
    user_hash: user.user_hash
  };

  if (typeof user.buyer_locations == "undefined") return ic_user;
  for (var i = 0; i < user.buyer_locations.length; i++) {
    ic_user['location_'+(i+1)] = user.buyer_locations[i].name;
  }

  return ic_user;
}
